import { api } from '@creditsights/api-ui-web';

interface CreateSessionResponse {
  rdr_auth_chatbot: string;
}

export const createSession = async (): Promise<CreateSessionResponse> => {
  const { data } = await api.get('/cs-genie/v1/session');
  return data;
};
